export const GA_EVENTS = {
  USER_CLICK : "User_Click",
  LOGIN_SUCCESS : "Login_Successful",
  LOGIN_FAIL: "Login_Unsuccessful",
  DYNAMIC_REPORT_REQUEST: "Dynamic_Report_Request",
  RECON_ENGINE_REQUEST: "Recon_Engine_Request"
};

export const GA_CATEGORIES = {
  LOGIN : "Login"
}